import useragent from '@finance/useragent'

export const getClientInfo = (requestInfo) => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      window.sui.getClientInfo({
        requestInfo,
        success: (res) => {
          if (res.code !== 0) {
            reject(new Error(res.message || '获取信息失败'))
            return
          }
          resolve(res.result)
        },
        error: () => {
          reject(new Error('获取信息失败'))
        }
      })
    })
  })
}

/**
 * 获取手机信息
 */
export const getPhoneInfo = () => {
  return new Promise((resolve, reject) => {
    getClientInfo(['phoneInfo']).then((res) => {
      if (res && res.phoneInfo && res.phoneInfo.code === 0) {
        resolve(res.phoneInfo.result)
        return
      }
      reject(new Error('获取手机信息失败'))
    }).catch((e) => {
      reject(e)
    })
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return new Promise((resolve, reject) => {
    getClientInfo(['userInfo']).then((res) => {
      if (res && res.userInfo && res.userInfo.code === 0) {
        resolve(res.userInfo.result)
        return
      }
      reject(new Error('获取用户信息失败'))
    }).catch((e) => {
      reject(e)
    })
  })
}